import { Link as RouterLink } from 'react-router-dom';
import { LINK_MIXIN } from 'style/mixins';
import styled from 'styled-components';

export const StyledExternalLink = styled.a`
  &:not(.plain) {
    ${LINK_MIXIN}
  }
  &.plain {
    text-decoration: none;
    color: inherit;
  }
`;

export const StyledInternalLink = styled(RouterLink)`
  &:not(.plain) {
    ${LINK_MIXIN}
  }
  &.plain {
    text-decoration: none;
    color: inherit;
  }
`;
